import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, BellRing } from "lucide-react";
import { useSite } from "../context/SiteContext";
import { SpotifyIcon, AppleMusicIcon } from "./BrandIcons";
import { trackClick } from "../lib/analytics";

export const PreSave = () => {
  const site = useSite();
  const p = site?.presave;
  if (!p || !p.enabled) return null;

  const links = [
    p.spotify_url && { id: "spotify-presave", label: "Spotify", url: p.spotify_url, Icon: SpotifyIcon },
    p.apple_url && { id: "apple-presave", label: "Apple Music", url: p.apple_url, Icon: AppleMusicIcon },
  ].filter(Boolean);

  return (
    <section id="presave" data-testid="presave-section" className="py-24 md:py-32 relative">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(212,175,55,0.08),transparent_60%)] pointer-events-none" />
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="backdrop-blur-2xl bg-white/[0.02] border border-gold/25 shadow-[0_8px_60px_rgba(212,175,55,0.12)] px-6 py-12 sm:px-14 sm:py-16 text-center"
        >
          <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.35em] text-gold border border-gold/40 px-4 py-2">
            <BellRing className="w-3.5 h-3.5" /> Pré-enregistrement
          </span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-7 leading-tight text-white">
            {p.title}
          </h2>
          {p.subtitle && (
            <p className="text-base lg:text-lg font-light text-[#B8B8B8] leading-relaxed mt-5 max-w-xl mx-auto text-hover">
              {p.subtitle}
            </p>
          )}

          {links.length > 0 && (
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
              {links.map((l) => (
                <a
                  key={l.id}
                  href={l.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackClick(l.id)}
                  data-testid={`presave-${l.id}`}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2.5 bg-gold text-black font-medium px-9 py-4 hover:bg-gold-light transition-colors duration-300 text-sm tracking-wide"
                >
                  <l.Icon size={18} /> Pré-enregistrer sur {l.label}
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              ))}
            </div>
          )}
          {p.note && <p className="text-xs text-[#8A8A8A] mt-6 tracking-wide">{p.note}</p>}
        </motion.div>
      </div>
    </section>
  );
};
